import PropTypes from 'prop-types'
import { Check } from 'lucide-react'

import { CarImageHolder } from '@components/car-image-holder'
import { AdasBox, AdasImage } from '@components/wrapper-components'

export const VehicleInfoDetails = (props) => {
  const { data } = props
  const imageUrl = data?.imageUrl
  const vehicleTitle = data?.model ? `${data.year} ${data.make} ${data.model} ${data.trim || ''}`.trim() : null
  const safetyItems = (data?.safetySystemsItems || [])
    .slice()
    .sort((a, b) => (a.feature_name || '').toLowerCase().localeCompare((b.feature_name || '').toLowerCase()))

  return (
    <AdasBox className='mt-4'>
      {/* Light gray card — real vehicle image (thumbnail) when available, otherwise the car illustration */}
      <AdasBox className='flex h-[260px] w-full items-center justify-center rounded-2xl bg-[#F1F3F5] px-6'>
        {imageUrl ? (
          <AdasImage src={imageUrl} alt='vehicle' className='max-h-full max-w-[420px] w-full object-contain' />
        ) : (
          <AdasBox className='flex h-full w-full max-w-[520px] items-center justify-center'>
            <CarImageHolder showText={false} />
          </AdasBox>
        )}
      </AdasBox>

      {/* Title + VIN */}
      {vehicleTitle && <h3 className='mt-5 text-[18px] font-bold text-[#0A1628]'>{vehicleTitle}</h3>}
      {data?.vin && <div className='mt-1 font-mono text-[13px] uppercase tracking-wider text-[#6B7280]'>VIN: {data.vin}</div>}

      <hr className='my-5 border-[#EBEDF0]' />

      {/* Installed safety systems */}
      <div className='mb-3 flex items-center gap-2'>
        <span className='text-[12px] font-bold uppercase tracking-wide text-[#475569]'>Installed Safety Systems</span>
        <span className='inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#E8EFFF] px-1.5 text-[11px] font-semibold text-[#1F6FEB]'>
          {safetyItems.length}
        </span>
      </div>
      {safetyItems.length > 0 ? (
        <ul className='grid grid-cols-1 gap-x-6 gap-y-2 md:grid-cols-2'>
          {safetyItems.map((safety, index) => (
            <li key={index} className='flex items-start gap-2 text-[13px] text-[#0A1628]'>
              <span className='mt-0.5 inline-flex h-4 w-4 flex-none items-center justify-center rounded-full bg-[#E8EFFF] text-[#1F6FEB]'>
                <Check className='h-3 w-3' strokeWidth={3} />
              </span>
              <span>{safety.feature_name}</span>
            </li>
          ))}
        </ul>
      ) : (
        <div className='text-[13px] text-[#6B7280]'>No safety systems detected</div>
      )}
    </AdasBox>
  )
}

VehicleInfoDetails.propTypes = {
  data: PropTypes.object,
  isQuote: PropTypes.bool,
  disabled: PropTypes.bool,
  hideAddRemoveSystems: PropTypes.bool
}
